<div class="container" [class.container--muted]="getUserSelection">
    <div
        class="container__outer"
        appZoom
        appPanPoint
        appDoubleTappable
        [drawingActive]="drawingActive"
    >
        <div class="container__inner">
            <div class="container__wrapper">
                <div class="container__content" appScale>
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    </div>
</div>
@if (getUserSelection) {
<app-drawing-canvas
    [isDrawingMode]="false"
    (selected)="onUserSelection($event)"
></app-drawing-canvas>
}
